import { useParams, Link } from "react-router-dom";

const products = {
  1: {
    name: "Face Recognition Attendance System",
    image:
      "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=1200",
    description:
      "Advanced AI-powered face recognition attendance system designed for offices, factories, educational institutions, and enterprises.",
    features: [
      "AI Face Recognition",
      "Touchless Attendance",
      "Cloud Dashboard",
      "Real-time Monitoring",
      "Mobile App Support",
      "Employee Reports",
    ],
  },

  2: {
    name: "Biometric Fingerprint Device",
    image:
      "https://images.unsplash.com/photo-1555949963-aa79dcee981c?w=1200",
    description:
      "Fast and secure fingerprint attendance and access control system.",
    features: [
      "Fingerprint Authentication",
      "RFID Support",
      "Attendance Reports",
      "Access Control",
      "Multi-user Support",
    ],
  },

  3: {
    name: "RFID Access Control System",
    image:
      "https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=1200",
    description:
      "Secure building access management using RFID cards and smart credentials.",
    features: [
      "RFID Card Access",
      "Door Lock Integration",
      "Access Logs",
      "Cloud Management",
    ],
  },
};

const ProductDetails = () => {
  const { id } = useParams();

  const product = products[id];

  if (!product) {
    return (
      <div className="py-24 text-center">
        <h1 className="text-3xl font-bold">Product Not Found</h1>
      </div>
    );
  }

  return (
    <section className="py-20 bg-white min-h-screen">
      <div className="max-w-7xl mx-auto px-6">

        <Link
          to="/products"
          className="inline-flex items-center text-cyan-600 mb-8"
        >
          ← Back to Products
        </Link>

        <div className="grid lg:grid-cols-2 gap-12 items-center">

          <div>
            <img
              src={product.image}
              alt={product.name}
              className="rounded-3xl shadow-xl w-full"
            />
          </div>

          <div>

            <h1 className="text-5xl font-bold text-slate-900 mb-6">
              {product.name}
            </h1>

            <p className="text-slate-600 text-lg leading-relaxed mb-8">
              {product.description}
            </p>

            <h3 className="text-2xl font-bold mb-4">
              Key Features
            </h3>

            <ul className="space-y-3 mb-10">
              {product.features.map((feature, index) => (
                <li
                  key={index}
                  className="flex items-center gap-3"
                >
                  <span className="text-cyan-600">✓</span>
                  {feature}
                </li>
              ))}
            </ul>

            <Link
              to="/contact"
              className="bg-cyan-600 hover:bg-cyan-700 text-white px-8 py-4 rounded-xl font-semibold"
            >
              Request Quote
            </Link>

          </div>

        </div>
      </div>
    </section>
  );
};

export default ProductDetails;